import { truncateText } from "@jti/fe-common";
import { type ApiMagentoPurchaseType } from "@jti/magento-types";
import { Tooltip } from "@jti/ui/components/Tooltip";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ConsumablesSectionTitle } from "../ConsumablesFormSectionTitle";

import styles from "../../ConsumablesForm.module.scss";

const MAX_TOOLTIP_LENGTH = 130;

type OrderFrequencyGroupTitleProps = {
  step: number;
  purchaseType: ApiMagentoPurchaseType;
};

export const ConsumablesPurchaseTypeSectionTitle = ({ step, purchaseType }: OrderFrequencyGroupTitleProps) => {
  const { __ } = useTranslations();

  const purchaseModeTooltipText = __(`product.info.purchase_type.${purchaseType}`);

  return (
    <ConsumablesSectionTitle translationKey="consumablesForm.section.purchase_type.title" stepCount={step}>
      <div className={styles.consumablesPurchaseTypeSectionTitleTooltipWrapper}>
        <Tooltip content={<span>{truncateText(purchaseModeTooltipText, MAX_TOOLTIP_LENGTH)}</span>} size="small" />
      </div>
    </ConsumablesSectionTitle>
  );
};
